import React from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { SovosSelect } from 's1-ui';
import MenuItem from '@material-ui/core/MenuItem';
import customTheme from 'commonComponents/whiteTheme';
import { states } from 'data/LicenseTypes/states';

function getOnChangeWrapper(onChange) {
  return function onChangeWrapper(e) {
    onChange(e.target.value);
  };
}

const customMuiTheme = createMuiTheme({ ...customTheme });

const StateDropDown = ({ value, onChange, style }) => (
  <MuiThemeProvider theme={ customMuiTheme }>
    <SovosSelect
      value={ value }
      onChange={ getOnChangeWrapper(onChange) }
      style={ style }
      variant="outlined"
      displayEmpty
    >
      <MenuItem value="" disabled>
        Select State
      </MenuItem>
      {states.map(state => (
        <MenuItem key={ state.Code } value={ state.Code }>
          { state.Name }
        </MenuItem>
      ))}
    </SovosSelect>
  </MuiThemeProvider>
);

StateDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

StateDropDown.defaultProps = {
  value: 'NULL',
  onChange: () => {},
  style: undefined
};

export default StateDropDown;
